import { OFFICIAL_POST_IT_SLOTS } from '../data/bossFinalOfficialCarSlots';
import { CAR_SCALE } from '../data/bossFinalCarLayout';
import { BOSS_FINAL_HIGHLIGHT_LIMIT } from '../data/bossFinalTimeline';

function condensedText (value) {
    const normalized = String(value ?? '').replace(/\s+/g, ' ').trim();
    return normalized.length > 100 ? `${normalized.slice(0, 97)}...` : normalized;
}

/** Original SVG paper, fold and outline; live insight text remains dynamic. */
export class BossFinalInsightCard {
    constructor (scene, insight, index) {
        const slot = OFFICIAL_POST_IT_SLOTS[index % OFFICIAL_POST_IT_SLOTS.length];
        const resolution = index < BOSS_FINAL_HIGHLIGHT_LIMIT ? 4 : 1;
        const key = `boss-official-note-${index % OFFICIAL_POST_IT_SLOTS.length}-${resolution}`;
        if (!scene.textures.exists(key)) {
            const texture = scene.textures.createCanvas(key, 84 * resolution, 84 * resolution);
            const context = texture.getContext();
            context.scale(resolution, resolution);
            context.translate(42 - slot.x, 42 - slot.y);
            [slot.color, slot.foldColor, '#1A1A1A'].forEach((color, pathIndex) => {
                context.fillStyle = color;
                context.fill(new Path2D(slot.paths[pathIndex]));
            });
            texture.refresh();
        }
        this.container = scene.add.container(0, 0).setDepth(index);
        const paper = scene.add.image(0, 0, key).setScale(CAR_SCALE / resolution);
        const text = scene.add.text(0, -1, condensedText(insight.texto), {
            fontFamily: 'Arial, sans-serif',
            fontSize: '5px',
            resolution,
            color: '#1a1a1a',
            align: 'center',
            wordWrap: { width: 34, useAdvancedWrap: true },
            fixedWidth: 34,
            fixedHeight: 35
        }).setOrigin(0.5);
        this.container.add([paper, text]);
    }

    setTransform ({ x, y, alpha = 1, scale = 1, depth = 0 }) {
        this.container.setPosition(x, y).setAlpha(alpha).setScale(scale).setDepth(depth);
    }

    destroy () {
        this.container.destroy(true);
    }
}
